class VivicatCommunity extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-vivicat-community-track]');
    this.prev = this.querySelector('[data-vivicat-community-prev]');
    this.next = this.querySelector('[data-vivicat-community-next]');
    this.modal = this.querySelector('[data-vivicat-community-modal]');
    this.modalImage = this.querySelector('[data-vivicat-community-modal-image]');
    this.modalAuthor = this.querySelector('[data-vivicat-community-modal-author]');
    this.modalStars = this.querySelector('.vivicat-community-modal .vivicat-review-stars');
    this.modalBody = this.querySelector('[data-vivicat-community-modal-body]');
    this.lastFocusedCard = null;

    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.track?.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    this.querySelectorAll('[data-vivicat-community-photo]').forEach((button) => {
      button.addEventListener('click', () => this.openModal(button));
    });

    this.modal?.querySelectorAll('[data-vivicat-community-close]').forEach((button) => {
      button.addEventListener('click', () => this.closeModal());
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeModal();
    });

    this.updateButtons();
  }

  scrollByCard(direction) {
    if (!this.track) return;

    const card = this.track.querySelector('.vivicat-community__card');
    const distance = card ? card.getBoundingClientRect().width + 12 : this.track.clientWidth;
    this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.track || !this.prev || !this.next) return;

    this.prev.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }

  openModal(button) {
    if (!this.modal || !this.modalImage) return;

    this.lastFocusedCard = button;
    this.modalImage.src = button.dataset.fullSrc;
    this.modalImage.alt = button.dataset.fullAlt || '';
    this.modalAuthor.textContent = button.dataset.author || '';
    this.modalBody.textContent = button.dataset.body || '';

    const rating = Number(button.dataset.rating || 0);
    if (this.modalStars) {
      this.modalStars.style.setProperty('--vivicat-review-rating', `${Math.max(0, Math.min(5, rating)) * 20}%`);
      this.modalStars.setAttribute('aria-label', `${rating} out of 5 stars`);
      this.modalStars.hidden = rating <= 0;
    }

    this.modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    this.modal.querySelector('[data-vivicat-community-close]')?.focus();
  }

  closeModal() {
    if (!this.modal || this.modal.hidden) return;

    this.modal.hidden = true;
    this.modalImage.removeAttribute('src');
    document.documentElement.classList.remove('overflow-hidden');
    this.lastFocusedCard?.focus();
  }
}

customElements.define('vivicat-community', VivicatCommunity);
